var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('modal',{attrs:{"id":"MultiaccountOrderModal","name":_vm.uniqueId}},[_c('Trading',{attrs:{"is-modal":true,"placement":_vm.placement,"pair":_vm.pair,"unique-id":_vm.uniqueId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }